import { connect } from 'react-redux';
import { compose } from 'redux';

import contractActionsCreators from '_store/_actions/contract';

import Contracts from './Contracts';

const mapStateToProps = state => ({
  contracts: state.contracts?.contracts || [],
  activeCompany: state.company.activeCompany,
  user: state.auth.user,
});

const mapDispatchToProps = {
  onFetchAllContracts: contractActionsCreators.fetchAllContracts,
  onFetchContract: contractActionsCreators.fetchContract,
  onAddContract: contractActionsCreators.addContract,
  onDeleteContract: contractActionsCreators.deleteContract,
  onUpdateContract: contractActionsCreators.updateContract,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Contracts);
